export enum SupportedThemes {
  BoW = 'BoW',
  WoB = 'WoB',
  Olivia = 'Olivia',
}

export enum SupportedScheme {
  Ziranma = 'ziranma',
  Guobiao = 'guobiao',
  Pinyinjiajia = 'pinyinjiajia',
  Sougou = 'sougou',
  Weiruan = 'weiruan',
  Xiaohe = 'xiaohe',
  ZhinengABC = 'zhinengABC',
  Ziguang = 'ziguang',
}

export enum SupportedMode {
  Counted = 'Counted',
}

export enum GlobalStatus {
  Init = 'Init',
  Started = 'Started',
  Suspended = 'Suspended',
  Ended = 'Ended',
}
